function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18604",
  "data-name": "Group 18604",
  transform: "translate(-664.491 40.641)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_16942",
  "data-name": "Group 16942",
  transform: "translate(989.106 256.359)",
  opacity: 0.294
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_16960",
  "data-name": "Group 16960",
  transform: "translate(907.491 311.677)",
  opacity: 0.19
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7518-2",
  "data-name": "Rectangle 7518",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(4.14)",
  fill: "#484751"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7519-2",
  "data-name": "Rectangle 7519",
  width: 1.656,
  height: 9.936,
  rx: 0.828,
  transform: "translate(9.936 4.14) rotate(90)",
  fill: "#484751"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2778",
  "data-name": "Ellipse 2778",
  transform: "translate(1037.698 334.313)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.16
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2779",
  "data-name": "Ellipse 2779",
  transform: "translate(1036.568 276.574)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.17
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_2780",
  "data-name": "Ellipse 2780",
  transform: "translate(923.026 328.184)",
  fill: "#fff",
  stroke: "#484751",
  strokeWidth: 2,
  opacity: 0.294
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 3.726,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.726,
  cy: 3.726,
  r: 2.726,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_17279",
  "data-name": "Group 17279",
  transform: "translate(939.284 280.395)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_17278",
  "data-name": "Group 17278",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3503",
  "data-name": "Group 3503",
  opacity: 0.996
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_5369",
  "data-name": "Path 5369",
  d: "M227.557,727.683H205.886V671.839h33.671v24.1h2.386V670.458a1.3,1.3,0,0,0-1.193-1.382H204.693a1.3,1.3,0,0,0-1.193,1.382v58.608a1.3,1.3,0,0,0,1.193,1.382h22.058Z",
  transform: "translate(-203.5 -669.076)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5370",
  "data-name": "Path 5370",
  d: "M221.622,680.681h-8.651a1.193,1.193,0,0,1,0-2.386h8.651a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -671.799)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5371",
  "data-name": "Path 5371",
  d: "M237.363,688.583H212.971a1.193,1.193,0,0,1,0-2.386h24.392a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -672.137)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5372",
  "data-name": "Path 5372",
  d: "M237.363,696.485H212.971a1.193,1.193,0,1,1,0-2.386h24.392a1.193,1.193,0,1,1,0,2.386Z",
  transform: "translate(-205.945 -673.55)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5373",
  "data-name": "Path 5373",
  d: "M229.426,704.388H214.06c-1.262,0-2.282-.535-2.282-1.193S212.8,702,214.06,702h15.366c1.262,0,2.282.535,2.282,1.193S230.688,704.388,229.426,704.388Z",
  transform: "translate(-205.945 -674.962)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5374",
  "data-name": "Path 5374",
  d: "M221,712.29h-8.031a1.193,1.193,0,1,1,0-2.386H221a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -676.375)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5375",
  "data-name": "Path 5375",
  d: "M221,720.192h-8.031a1.193,1.193,0,1,1,0-2.386H221a1.193,1.193,0,0,1,0,2.386Z",
  transform: "translate(-205.945 -677.788)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5376",
  "data-name": "Path 5376",
  d: "M221,728.094h-8.031a1.193,1.193,0,1,1,0-2.385H221a1.193,1.193,0,1,1,0,2.385Z",
  transform: "translate(-205.945 -679.201)",
  fill: "#8c9cac"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31241",
  "data-name": "Path 31241",
  d: "M221,728.094h-8.031a1.193,1.193,0,1,1,0-2.385H221a1.193,1.193,0,1,1,0,2.385Z",
  transform: "translate(-205.945 -673.083)",
  fill: "#8c9cac"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group_18603",
  "data-name": "Group 18603",
  transform: "translate(976.493 281.643)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18544",
  "data-name": "Group 18544",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18071",
  "data-name": "Group 18071",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18062",
  "data-name": "Group 18062"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_18053",
  "data-name": "Group 18053"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_171",
  "data-name": "Subtraction 171",
  d: "M3.344,39.812H0V38.452a11.7,11.7,0,0,1,11.7-11.7H21.734a11.7,11.7,0,0,1,11.7,11.7V39.81H30.093V38.452a8.368,8.368,0,0,0-8.359-8.358H11.7a8.368,8.368,0,0,0-8.359,8.358v1.359ZM16.718,23.406A11.7,11.7,0,0,1,8.444,3.429a11.7,11.7,0,0,1,16.55,16.55A11.626,11.626,0,0,1,16.718,23.406Zm0-20.062A8.359,8.359,0,1,0,25.078,11.7,8.368,8.368,0,0,0,16.718,3.344Z",
  fill: "#8c9cac"
})))))), /*#__PURE__*/React.createElement("line", {
  id: "Line_2216",
  "data-name": "Line 2216",
  x2: 31.609,
  transform: "translate(1019.775 297.921)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2217",
  "data-name": "Line 2217",
  x2: 33.988,
  transform: "translate(1019.435 307.437)",
  fill: "none",
  stroke: "#c9c9cc",
  strokeWidth: 1,
  strokeDasharray: 6
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Union_57",
  "data-name": "Union 57",
  d: "M19.84,24.986a2.249,2.249,0,0,1-.9-2.162l.994-6.4-4.58-4.6a2.242,2.242,0,0,1,1.242-3.8l6.414-1.042,2.98-5.761a2.262,2.262,0,0,1,4.012,0l2.977,5.761L39.4,8.02a2.245,2.245,0,0,1,1.236,3.8l-4.584,4.6.99,6.4a2.24,2.24,0,0,1-.9,2.162,2.28,2.28,0,0,1-2.344.188l-5.8-2.919-5.809,2.919a2.242,2.242,0,0,1-1.014.241A2.289,2.289,0,0,1,19.84,24.986ZM34.6,23.594a.46.46,0,0,0,.5-.038.47.47,0,0,0,.193-.46L34.16,15.808l5.215-5.231h0a.474.474,0,0,0,.117-.485.483.483,0,0,0-.375-.33L31.8,8.576,28.416,2.025a.462.462,0,0,0-.424-.259.472.472,0,0,0-.428.259L24.18,8.576l-7.3,1.185a.471.471,0,0,0-.381.33.465.465,0,0,0,.115.485l5.211,5.231L20.7,23.1a.457.457,0,0,0,.189.46.474.474,0,0,0,.5.038l6.6-3.321Zm18.881-.129L49.449,21.4l-4.025,2.065a.488.488,0,0,1-.686-.543l.756-4.331-3.236-3.068a.514.514,0,0,1,.266-.874l4.5-.634,2.006-3.962a.472.472,0,0,1,.85,0l2.006,3.962,4.5.634a.51.51,0,0,1,.26.874L53.4,18.59l.764,4.331a.5.5,0,0,1-.475.6A.467.467,0,0,1,53.482,23.465Zm-42.1,0L7.348,21.4,3.322,23.465a.488.488,0,0,1-.686-.543l.756-4.331L.156,15.522a.513.513,0,0,1,.266-.874l4.5-.634,2.006-3.962a.472.472,0,0,1,.85,0l2.008,3.962,4.5.634a.51.51,0,0,1,.258.874l-3.23,3.068.758,4.331a.5.5,0,0,1-.475.6A.449.449,0,0,1,11.381,23.465Z",
  transform: "translate(93.527 1844.904)",
  fill: "#f3994e"
});

function SvgSkillRatingDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.933,
    height: 85.47,
    viewBox: "0 0 145.933 85.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "skill_rating_details",
    "data-name": "skill rating details",
    transform: "translate(-243 -297)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_19787",
    "data-name": "Group 19787",
    transform: "translate(206.007 -1487.849)",
    style: {
      isolation: "isolate"
    }
  }, _ref3)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillRatingDetails);
export default __webpack_public_path__ + "static/media/skill-rating-details.1f55e3d1.svg";
export { ForwardRef as ReactComponent };